// extracted by mini-css-extract-plugin
export default {"banner":"SmallBanner_banner__gQfM1"};